<template>
  <div class="base-content">
    <el-form label-postion="left" label-width="140px">
      <!-- <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="一键报警账户" prop="alarm_account">
            <el-input v-model="baseInfo.alarm_account"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="一键报警密码" prop="alarm_password">
            <el-input v-model="baseInfo.alarm_password"></el-input>
          </el-form-item>
        </el-col>
      </el-row> -->

      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="路灯协议" prop="lamp_type">
            <el-checkbox-group v-model="lampType">
              <el-checkbox label="1">Mqtt</el-checkbox>
              <el-checkbox label="2">Zigbee</el-checkbox>
              <el-checkbox label="3">LoRa</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="亮度系数" prop="light_per">
            <el-input v-model="baseInfo.light_per"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="windows服务器IP" prop="broadcast">
            <el-input v-model="baseInfo.broadcast"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <!-- <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="oneNet平台key" prop="api_key">
            <el-input v-model="baseInfo.api_key"></el-input>
          </el-form-item>
        </el-col>
      </el-row> -->

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="萤石云key" prop="app_key">
            <el-input v-model="baseInfo.app_key"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="萤石云secret" prop="app_secret">
            <el-input v-model="baseInfo.app_secret"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="充电桩账号" prop="charging_account">
            <el-input v-model="baseInfo.charging_account"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="充电桩密码" prop="charging_password">
            <el-input v-model="baseInfo.charging_password"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="信息发布账号" prop="information_account">
            <el-input v-model="baseInfo.information_account"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="信息发布密码" prop="information_password">
            <el-input v-model="baseInfo.information_password"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item label="所在地址选点" prop="alarm_account">
        <div class="map-container">
            <el-amap
              ref="map"
              vid="amap"
              :center="myMap.center"
              :zoom="myMap.zoom"
              :plugin="myMap.plugin"
              class="amap-demo"
              mapStyle="amap://styles/light"
              :events="myMap.events"
            >
              <el-amap-circle-marker
                :center="myMap.markercenter"
                :radius="myMap.radius"
                fillColor="gray"
                strokeColor="#fff"
                :fillOpacity="myMap.fillOpacity"
              >
              </el-amap-circle-marker>
            </el-amap>
          </div>
      </el-form-item>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="经度" prop="lng">
            <el-input v-model="baseInfo.lng"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="纬度" prop="alarm_password">
            <el-input v-model="baseInfo.lat"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      
    </el-form>
    <div class="dialog_footer">
      <el-button @click="cancel">取消</el-button>
      <el-button type="primary" @click.prevent="saveInfoData">保存</el-button>
    </div>
  </div>
</template>
<script>
import adminsApi from "@/api/auth/admins";
export default {
  name: "BaseSet",
  props: {
    userId: {
      type: Number,
    },
  },
  data() {
    const vm = this;
    return {
      lampType: [],
      baseInfo: {
      },
      myMap: {
        center: [118.777929, 32.058456],
        markercenter: [118.777929, 32.058456],
        events: {
          mapmove: () => {
            this.handleMove();
          },
        },
        zoom: 12,
        radius: 10,
        fillOpacity: 1,
      }
    };
  },
  methods: {
    getInfoData() {
      adminsApi.getSystemBase(this.userId).then((res) => {
        if (res.data.code === 1000) {
          this.baseInfo = res.data.data;
          let resCenter = res.data.data.center.split(",")
          let lamp_type = res.data.data.lamp_type
          if(lamp_type){
            this.lampType = lamp_type.split(',')
          }
          this.myMap.center = [parseFloat(resCenter[0]),parseFloat(resCenter[1])]
          this.myMap.markercenter = [parseFloat(resCenter[0]),parseFloat(resCenter[1])]
        }
      });
    },

    saveInfoData() {
      this.baseInfo.center = this.baseInfo.lng+','+this.baseInfo.lat
      if (this.lampType.length<1) {
        this.$message.error("请选择协议！")
        return
      }
      this.baseInfo.lamp_type=this.lampType.join(',')
      adminsApi.EditSystemBase(this.userId, this.baseInfo).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success("更改成功！");
          this.$emit('closeMethod')
        }
      });
    },

    cancel() {
      this.$emit("closeMethod");
    },
    handleMove() {
      this.myMap.markercenter = this.$refs.map.$$getCenter();
      this.baseInfo.lng = this.myMap.markercenter[0]
      this.baseInfo.lat = this.myMap.markercenter[1]
    },
  },
  mounted() {
    this.getInfoData();
  },
};
</script>
<style lang='less' scoped>
.base-content{
  width:100%;
  position: relative;
  .map-container {
    width:100%;
    height: 260px;
    margin-bottom: 10px;
  }
  .el-row{
    border-bottom: 1px solid #eee;
    padding-bottom: 0;
    margin-bottom: 20px;
  }
}
</style>